var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "node-installation-matrix" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Languages"), name: "lang" } },
            [
              _c(
                "div",
                { staticClass: "lang-table" },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "table",
                      attrs: {
                        data: _vm.nodeList,
                        "header-cell-style": {
                          background: "rgb(48, 65, 86)",
                          color: "white",
                          height: "50px"
                        },
                        border: ""
                      },
                      on: { "row-click": _vm.onLangTableRowClick }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("Node"),
                          width: "240px",
                          prop: "name",
                          fixed: ""
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("nodeList.type"),
                          width: "120px",
                          fixed: ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.is_master
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "primary" } },
                                      [_vm._v(_vm._s(_vm.$t("Master")))]
                                    )
                                  : _c(
                                      "el-tag",
                                      { attrs: { type: "warning" } },
                                      [_vm._v(_vm._s(_vm.$t("Worker")))]
                                    )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("Status"),
                          width: "120px",
                          fixed: ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.status === "offline"
                                  ? _c("el-tag", { attrs: { type: "info" } }, [
                                      _vm._v(_vm._s(_vm.$t("Offline")))
                                    ])
                                  : scope.row.status === "online"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "success" } },
                                      [_vm._v(_vm._s(_vm.$t("Online")))]
                                    )
                                  : _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [_vm._v(_vm._s(_vm.$t("Unavailable")))]
                                    )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._l(_vm.langs, function(l) {
                        return _c("el-table-column", {
                          key: l.name,
                          attrs: { label: l.label, width: "220px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "header-with-action" },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.column.label))
                                        ]),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onInstallLangAll(
                                                  scope.column.label,
                                                  $event
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("Install")) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              },
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm.getLangInstallStatus(
                                      scope.row._id,
                                      l.name
                                    ) === "installed"
                                      ? [
                                          _c(
                                            "el-tag",
                                            { attrs: { type: "success" } },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-check"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("Installed")) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm.getLangInstallStatus(
                                          scope.row._id,
                                          l.name
                                        ) === "installing"
                                      ? [
                                          _c(
                                            "el-tag",
                                            { attrs: { type: "warning" } },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-loading"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("Installing")) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      : [
                                          "installing-other",
                                          "not-installed"
                                        ].includes(
                                          _vm.getLangInstallStatus(
                                            scope.row._id,
                                            l.name
                                          )
                                        )
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "cell-with-action" },
                                            [
                                              _c(
                                                "el-tag",
                                                { attrs: { type: "danger" } },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-error"
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("Not Installed")
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "mini"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onInstallLang(
                                                        scope.row._id,
                                                        scope.column.label,
                                                        $event
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("Install")
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      : _vm.getLangInstallStatus(
                                          scope.row._id,
                                          l.name
                                        ) === "na"
                                      ? [
                                          _c(
                                            "el-tag",
                                            { attrs: { type: "info" } },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-question"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("N/A")) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Dependencies"), name: "dep" } },
            [
              _c(
                "el-form",
                { staticClass: "search-form", attrs: { inline: "" } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        staticStyle: { width: "240px" },
                        attrs: { placeholder: _vm.$t("Search Dependencies") },
                        model: {
                          value: _vm.depName,
                          callback: function($$v) {
                            _vm.depName = $$v
                          },
                          expression: "depName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            icon: "el-icon-search",
                            type: "success"
                          },
                          on: { click: _vm.onSearch }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("Search")) + " ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-checkbox", {
                        attrs: { label: _vm.$t("Show installed") },
                        on: { change: _vm.onIsShowInstalledChange },
                        model: {
                          value: _vm.isShowInstalled,
                          callback: function($$v) {
                            _vm.isShowInstalled = $$v
                          },
                          expression: "isShowInstalled"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.activeLang,
                    callback: function($$v) {
                      _vm.activeLang = $$v
                    },
                    expression: "activeLang"
                  }
                },
                _vm._l(_vm.langsWithDeps, function(l) {
                  return _c("el-tab-pane", {
                    key: l.name,
                    attrs: { name: l.name, label: l.label }
                  })
                }),
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.isDepsLoading,
                      expression: "isDepsLoading"
                    }
                  ],
                  staticClass: "table",
                  attrs: {
                    height: "calc(100vh - 320px)",
                    data: _vm.computedDepsSet,
                    "header-cell-style": {
                      background: "rgb(48, 65, 86)",
                      color: "white",
                      height: "50px"
                    },
                    border: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("Dependency"),
                      prop: "name",
                      width: "180px",
                      fixed: ""
                    }
                  }),
                  false
                    ? _c(
                        "el-table-column",
                        {
                          attrs: {
                            label: _vm.$t("Install on All Nodes"),
                            width: "120px",
                            align: "center",
                            fixed: ""
                          }
                        },
                        [
                          [
                            _c(
                              "el-button",
                              { attrs: { size: "mini", type: "primary" } },
                              [_vm._v(" " + _vm._s(_vm.$t("Install")) + " ")]
                            )
                          ]
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._l(_vm.activeNodes, function(n) {
                    return _c("el-table-column", {
                      key: n._id,
                      attrs: { label: n.name, width: "220px", align: "center" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function(scope) {
                              return [
                                _vm._v(" " + _vm._s(scope.column.label) + " ")
                              ]
                            }
                          },
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm.getDepStatus(n, scope.row) === "installed"
                                  ? _c(
                                      "div",
                                      { staticClass: "cell-with-action" },
                                      [
                                        _c(
                                          "el-tag",
                                          { attrs: { type: "success" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("Installed")) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "danger"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.uninstallDep(
                                                  n,
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("Uninstall")) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm.getDepStatus(n, scope.row) ===
                                    "installing"
                                  ? _c(
                                      "div",
                                      { staticClass: "cell-with-action" },
                                      [
                                        _c(
                                          "el-tag",
                                          { attrs: { type: "warning" } },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-loading"
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("Installing")) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm.getDepStatus(n, scope.row) ===
                                    "uninstalled"
                                  ? _c(
                                      "div",
                                      { staticClass: "cell-with-action" },
                                      [
                                        _c(
                                          "el-tag",
                                          { attrs: { type: "danger" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("Not Installed")
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "primary"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.installDep(
                                                  n,
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("Install")) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Web Driver", name: "webdriver" } },
            [
              _c(
                "div",
                { staticClass: "webdriver-table" },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "table",
                      attrs: {
                        data: _vm.nodeList,
                        "header-cell-style": {
                          background: "rgb(48, 65, 86)",
                          color: "white",
                          height: "50px"
                        },
                        border: ""
                      },
                      on: { "row-click": _vm.onLangTableRowClick }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("Node"),
                          width: "240px",
                          prop: "name",
                          fixed: ""
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("nodeList.type"),
                          width: "120px",
                          fixed: ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.is_master
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "primary" } },
                                      [_vm._v(_vm._s(_vm.$t("Master")))]
                                    )
                                  : _c(
                                      "el-tag",
                                      { attrs: { type: "warning" } },
                                      [_vm._v(_vm._s(_vm.$t("Worker")))]
                                    )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("Status"),
                          width: "120px",
                          fixed: ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.status === "offline"
                                  ? _c("el-tag", { attrs: { type: "info" } }, [
                                      _vm._v(_vm._s(_vm.$t("Offline")))
                                    ])
                                  : scope.row.status === "online"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "success" } },
                                      [_vm._v(_vm._s(_vm.$t("Online")))]
                                    )
                                  : _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [_vm._v(_vm._s(_vm.$t("Unavailable")))]
                                    )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._l(_vm.webdrivers, function(wd) {
                        return _c("el-table-column", {
                          key: wd.name,
                          attrs: { label: wd.label, width: "220px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "header-with-action" },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.column.label))
                                        ]),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onInstallLangAll(
                                                  scope.column.label,
                                                  $event
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("Install")) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              },
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm.getLangInstallStatus(
                                      scope.row._id,
                                      wd.name
                                    ) === "installed"
                                      ? [
                                          _c(
                                            "el-tag",
                                            { attrs: { type: "success" } },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-check"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("Installed")) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm.getLangInstallStatus(
                                          scope.row._id,
                                          wd.name
                                        ) === "installing"
                                      ? [
                                          _c(
                                            "el-tag",
                                            { attrs: { type: "warning" } },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-loading"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("Installing")) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      : [
                                          "installing-other",
                                          "not-installed"
                                        ].includes(
                                          _vm.getLangInstallStatus(
                                            scope.row._id,
                                            wd.name
                                          )
                                        )
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "cell-with-action" },
                                            [
                                              _c(
                                                "el-tag",
                                                { attrs: { type: "danger" } },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-error"
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("Not Installed")
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "mini"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onInstallLang(
                                                        scope.row._id,
                                                        scope.column.label,
                                                        $event
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("Install")
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      : _vm.getLangInstallStatus(
                                          scope.row._id,
                                          wd.name
                                        ) === "na"
                                      ? [
                                          _c(
                                            "el-tag",
                                            { attrs: { type: "info" } },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-question"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("N/A")) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }